// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UD-5","label":"styles_label__1HpMm"};